const categories = [
  {
    label: 'Soups',
    image: 'http://dev.muekarator.com/uploads/1774134963763-AFANG-SOUP-2500.jpg',
    color: 'bg-green-50',
  },
  {
    label: 'Banga Soup',
    image: 'http://dev.muekarator.com/uploads/1774134963859-niger-delta-banga-soup-recipe-img-7.jpg',
    color: 'bg-orange-50',
  },
  {
    label: 'Afang Soup',
    image: 'http://dev.muekarator.com/uploads/1774134963763-AFANG-SOUP-2500.jpg',
    color: 'bg-emerald-50',
  },
  {
    label: 'White Soup',
    image: 'http://dev.muekarator.com/uploads/1774134963848-images.webp',
    color: 'bg-amber-50',
  },
  {
    label: 'Jollof Rice',
    image: 'http://dev.muekarator.com/uploads/1774134963849-jollof_rice-1.jpg',
    color: 'bg-red-50',
  },
  {
    label: 'Pepper Soup',
    image: 'http://dev.muekarator.com/uploads/1774134963859-white%20soup.jpeg',
    color: 'bg-rose-50',
  },
  {
    label: 'Pounded Yam & Soup',
    image: 'http://dev.muekarator.com/uploads/1774134963833-Egusi-Soup-with-Pounded-Yam.webp',
    color: 'bg-yellow-50',
  },
  {
    label: 'Suya',
    image: 'http://dev.muekarator.com/uploads/1774134963830-air-fryer-suya-2.jpg',
    color: 'bg-teal-50',
  },
];

export default function FoodCategories() {
  return (
    <section className="bg-[#FAFAFA] py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-[#FFF8E6] text-[#D4970B] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Popular Naija Categories
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            What Nigerian dish are you feeling today?
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            Rich soups, fiery pepper soup, classic jollof, street suya and more — delivered hot and fresh.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4 md:gap-5">
          {categories.map((cat) => (
            <div
              key={cat.label}
              className="flex flex-col items-center gap-3 group cursor-pointer transition-all duration-300 hover:scale-[1.04]"
            >
              <div
                className={`w-full aspect-square rounded-2xl md:rounded-3xl ${cat.color} overflow-hidden shadow-sm group-hover:shadow-md transition-shadow duration-300`}
              >
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <span className="text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#009E81] transition-colors duration-300 text-center">
                {cat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}